module.exports = __webpack_public_path__ + "static/media/gloves.91a63a83.jpg";